import { render, staticRenderFns } from "./card_badges_count.vue?vue&type=template&id=7df8e96c&scoped=true"
import script from "./card_badges_count.vue?vue&type=script&lang=js"
export * from "./card_badges_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df8e96c",
  null
  
)

export default component.exports